import {createApi} from '@reduxjs/toolkit/query/react'

import {fetchBaseQuery} from '@vio/core/src/utils/network/fetchBaseQuery'

interface TranslateParams {
  text: string | string[]
  targetLanguage: string
}

interface Translation {
  translatedText: string
  detectedSourceLanguage?: string
}

interface TranslateApiResponse {
  data: {
    translations: Translation[]
  }
}

type TranslateResult = string | string[]

export const translationApi = createApi({
  reducerPath: 'translationApi',
  baseQuery: fetchBaseQuery({baseUrl: ''}),
  endpoints: builder => ({
    translate: builder.query<TranslateResult, TranslateParams>({
      query: ({text, targetLanguage}) => ({
        url: '/api/translate',
        method: 'POST',
        data: {text, targetLanguage}
      }),
      transformResponse: (response: TranslateApiResponse, _meta, arg) => {
        const {translations} = response.data

        if (Array.isArray(arg.text))
          return translations.map(t => t.translatedText)

        return translations[0]?.translatedText ?? ''
      },
      serializeQueryArgs: ({queryArgs}) =>
        JSON.stringify([queryArgs.text, queryArgs.targetLanguage])
    })
  })
})

export const {useTranslateQuery} = translationApi
